import { render, staticRenderFns } from "./ThemesModal.vue?vue&type=template&id=c9c15f96&scoped=true&"
import script from "./ThemesModal.vue?vue&type=script&lang=ts&"
export * from "./ThemesModal.vue?vue&type=script&lang=ts&"
import style0 from "./ThemesModal.vue?vue&type=style&index=0&id=c9c15f96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c15f96",
  null
  
)

export default component.exports